

export default class ReportTasksSummary_Settings {

    public projectId        : ID | null

    constructor(data: any) {
        this.projectId        = _.get(data, "projectId", null)
    }

    toJSON(): JSONObject {
        const result: JSONObject = {
            projectId        : this.projectId,
        }

        return result
    }
}
